import { useCallback, useRef } from 'react';

export function useTreeItemRow({ onRowClick }) {
  const actionsRef = useRef(null);
  const createRef = useRef(null);

  const handleRowClick = useCallback(
    (e) => {
      const actionsEl = e.target.closest('[data-tree-actions="true"]');
      const createEl = e.target.closest('[data-tree-create="true"]');
      if (actionsEl || createEl) return;
      if (onRowClick) onRowClick(e);
    },
    [onRowClick],
  );

  const buildActionClick = useCallback(
    (action) => (e) => {
      e.stopPropagation();
      action.onClick?.();
      actionsRef.current?.closeDropdown();
    },
    [],
  );

  const buildCreateActionClick = useCallback(
    (action) => (e) => {
      e.stopPropagation();
      action.onClick?.();
      createRef.current?.closeDropdown();
    },
    [],
  );

  return { actionsRef, createRef, handleRowClick, buildActionClick, buildCreateActionClick };
}

export default useTreeItemRow;
